import { ROUTES } from '@/lib/routes';

/**
 * Constantes pour l'authentification
 * Centralise les valeurs magiques et améliore la maintenabilité
 */

export const AUTH_CONSTANTS = {
  // Durées
  PASSWORD_RESET_REDIRECT_DELAY: 5000, // 5 secondes

  // Contraintes de validation
  MIN_PASSWORD_LENGTH: 6,

  // Routes (utilise les routes centralisées)
  ROUTES: {
    LOGIN: ROUTES.AUTH.LOGIN,
    HOME: ROUTES.DASHBOARD.HOME,
    FORGOT_PASSWORD: ROUTES.AUTH.FORGOT_PASSWORD,
    RESET_PASSWORD: ROUTES.AUTH.RESET_PASSWORD,
    AUTH_CALLBACK: ROUTES.AUTH.CALLBACK,
  },

  // Messages de succès
  SUCCESS_MESSAGES: {
    LOGIN: '✅ Connexion réussie !',
    PASSWORD_RESET_SENT: 'Un lien de réinitialisation a été envoyé à votre adresse email',
    PASSWORD_UPDATED: 'Votre mot de passe a été réinitialisé avec succès',
  },

  // Configuration Supabase
  SUPABASE_CONFIG: {
    AUTH: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce' as const,
    },
    GLOBAL: {
      headers: {
        'X-Client-Info': 'desertours-crm@1.0.0',
      },
    },
  },
} as const;
